import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { company, whatsappUrl, regionHubs } from "../data/site";
import { services } from "../data/services";
import logo from "../assets/ruempeltaxi-logo.png";
import sponsorImg from "../assets/sponsor-tsv-neu-ulm-spartans.webp";

const legal = [
  { label: "Impressum", to: "/impressum" },
  { label: "Datenschutz", to: "/datenschutz" },
  { label: "Cookie-Einstellungen", to: "/cookie-einstellungen" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const isHome = useLocation().pathname === "/";
  return (
    <footer className="bg-brand-black text-light-gray" data-testid="site-footer">
      {isHome && (
        <div className="border-b border-dark-gray" data-testid="footer-sponsor-strip">
          <div className="container-page flex flex-col items-center justify-center gap-3 py-5 text-sm text-light-gray/70 sm:flex-row sm:gap-5">
            <img
              src={sponsorImg}
              alt="Offizieller Sponsor TSV Neu-Ulm Spartans – Rümpeltaxi Altenstadt"
              className="h-12 w-auto rounded-sm"
              loading="lazy"
              decoding="async"
              data-testid="footer-sponsor-image"
            />
            <p>Rümpeltaxi ist offizieller Sponsor der TSV Neu-Ulm Spartans (American Football).</p>
          </div>
        </div>
      )}
      <div className="container-page grid grid-cols-2 gap-10 py-20 md:grid-cols-4 md:py-24">
        <div className="col-span-2 md:col-span-1">
          <img src={logo} alt="Rümpeltaxi" className="h-10 w-auto" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-light-gray/60">
            Entrümpelungen, Haushaltsauflösungen und Entsorgungen – persönlich, diskret und
            zuverlässig. Von der ersten Anfrage bis zur besenreinen Übergabe.
          </p>
          <div className="mt-6 flex flex-col gap-2 text-sm">
            <a href={company.phoneLink} className="flex items-center gap-2 hover:text-yellow" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-yellow" /> {company.phoneDisplay}
            </a>
            <a href={company.emailLink} className="flex items-center gap-2 hover:text-yellow" data-testid="footer-email">
              <Mail className="h-4 w-4 text-yellow" /> {company.email}
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-yellow"
              data-testid="footer-whatsapp"
            >
              <MessageCircle className="h-4 w-4 text-yellow" /> WhatsApp
            </a>
            <span className="flex items-start gap-2 text-light-gray/50" data-testid="footer-address">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-yellow" />
              <span>
                {company.name} · {company.owner}
                <br />
                {company.street}, {company.postal} {company.city}
                <br />
                Telefon {company.phoneDisplay}
              </span>
            </span>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-white">Leistungen</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-light-gray/60">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to={`/leistungen/${s.slug}`} className="hover:text-yellow">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-white">Einsatzgebiete</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-light-gray/60">
            {regionHubs.map((r) => (
              <li key={r.slug}>
                <Link to={`/einsatzgebiete/${r.slug}`} className="hover:text-yellow">
                  {r.short}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-white">Unternehmen</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-light-gray/60">
            <li><Link to="/ueber-uns" className="hover:text-yellow">Über uns</Link></li>
            <li><Link to="/referenzen" className="hover:text-yellow">Referenzen</Link></li>
            <li><Link to="/ratgeber" className="hover:text-yellow">Ratgeber</Link></li>
            <li><Link to="/geschaeftskunden" className="hover:text-yellow">Geschäftskunden</Link></li>
            <li><Link to="/kontakt" className="hover:text-yellow">Kontakt</Link></li>
          </ul>
          <h3 className="mt-8 font-heading text-sm font-bold uppercase tracking-widest text-white">Rechtliches</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-light-gray/60">
            {legal.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-yellow" data-testid={`footer-legal-${l.to}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-dark-gray">
        <div className="container-page flex flex-col items-center justify-between gap-3 py-6 text-xs text-light-gray/50 md:flex-row">
          <p>© {year} Rümpeltaxi. Alle Rechte vorbehalten.</p>
          <p>Entrümpelung · Haushaltsauflösung · Entsorgung · Umzug · Einlagerung</p>
        </div>
      </div>
    </footer>
  );
}
